/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Submit_JobsInputs */



/**
* | output |
* | --- |
* | "Submit {count} Jobs" |
*
* @param {Submit_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_jobs = /** @type {((inputs: Submit_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Soumettre ${i?.count} tâches`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Jobs einreichen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Invia ${i?.count} lavori`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Отправить вакансии ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Enviar ${i?.count} Empleos`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`提交 ${i?.count} 职位`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 求人を送信`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} नौकरियां जमा करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Enviar trabalhos ${i?.count}`)
	return /** @type {LocalizedString} */ (`Submit ${i?.count} Jobs`)
});